import { Grid } from '@mui/material';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React from 'react';

export const getCohortValue = (cohortValue: string, totalValue: string) => {
  return (
    <Grid
      container
      sx={{
        alignItems: 'center',
      }}
    >
      <Typography
        fontSize="20px"
        lineHeight="43px"
        textColor={patientAccessTheme.palette.text.highemphasis}
        fontType="medium"
        margin="0px 4px 0px 0px"
      >
        {cohortValue}
      </Typography>
      <Typography
        fontSize="14px"
        lineHeight="23px"
        textColor={patientAccessTheme.palette.text.lowemphasis}
        margin="4px 0px 0px 0px"
      >
        {'/ ' + totalValue}
      </Typography>
    </Grid>
  );
};
